/* global angular */
class checkImageModalCtrl {
    constructor($scope, $timeout, items1) {
        $scope.modaldata = items1
        if ($scope.modaldata[0].fileType === 'pdf') {
            $scope.isPdf = true
            $scope.pdfSrc = $scope.modaldata[0].storageKey
            $scope.title = 'pdf文件影像'
        } else {
            $scope.isPdf = false
            $scope.selectedIndex = 0
            $scope.mainImage = $scope.modaldata[0].storageKey
            angular.forEach($scope.modaldata, (item, index) => {
                $scope.modaldata[index].src = $scope.modaldata[index].storageKey
            })
            $scope.changeImage = function (index) {
                $scope.selectedIndex = index
                $scope.mainImage = $scope.modaldata[index].storageKey
            }
            $scope.title = `第${$scope.selectedIndex + 1}页，共${$scope.modaldata.length}页`
        }
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
    }
}

checkImageModalCtrl.$inject = ['$scope', '$uibModalInstance', 'items1']
export default checkImageModalCtrl



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/collection/checkImageModalCtrl.js